import { useEffect, useState } from 'react'
import { OrgChartComponent } from './OrgChart'
import { useDispatch, useSelector } from 'react-redux'
import { clubLoader, getClub, getTree } from '../state/clubSlice'
import esLocale from 'date-fns/locale/es'
import { Box } from '@material-ui/core'
import DateFnsUtils from '@date-io/date-fns'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import { format } from 'date-fns'

interface ClubComponentProps {
  userId: string
}

const ClubComponent: React.FC<ClubComponentProps> = ({ userId }) => {
  const dispatch = useDispatch()
  const [selectedDate, setSelectedDate] = useState(new Date())
  const clubData = useSelector(getTree)
  const { isLoading } = useSelector(clubLoader)

  function onNodeClick(nodeId: any) {
    // console.log('d3', d3.event);
    alert('clicked ' + nodeId)
  }
  useEffect(() => {
    dispatch(getClub({ date: format(selectedDate, 'yyyy/MM/dd'), userId }))
  }, [userId])

  const handleChangeDate = (date: Date) => {
    setSelectedDate(date)
    dispatch(getClub({ date: format(date, 'yyyy/MM/dd'), userId }))
  }

  const totalCompletedCases = clubData?.reduce((acc, item: any) => (item.isComplete ? acc + 1 : acc), 0)

  return (
    <div>
      <Box display="flex" flexDirection="row" padding="0 1rem">
        <Box
          display="flex"
          flexDirection="row"
          width="100%"
          alignItems="center"
          justifyContent="space-between"
          borderRadius="0.5rem"
          border="solid 2px #ff6900"
          marginTop="1em"
          boxShadow="0 4px 8px rgba(0, 0, 0, 0.1)"
          padding="1em"
        >
          <Box display="flex" flexDirection="row" alignItems="center" justifyContent="space-between">
            En el mes de:
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
              <DatePicker
                style={{
                  marginLeft: '1em',
                  borderColor: '#ffdda5'
                }}
                size="small"
                inputVariant="outlined"
                views={['year', 'month']} // Enables month selection
                disableFuture
                placeholder="Mes"
                openTo="month"
                cancelLabel="Cancelar"
                emptyLabel=""
                format="MMMM yyyy"
                value={selectedDate}
                onChange={e => handleChangeDate(e || selectedDate)}
                invalidDateMessage="Fecha incorrecta"
              />
            </MuiPickersUtilsProvider>
          </Box>
          <Box>Casos completados este mes: {totalCompletedCases}</Box>
        </Box>
      </Box>

      {isLoading ? (
        <Box display="flex" width="100vw" justifyContent="center">
          <br />
          Cargando datos...
        </Box>
      ) : (
        <OrgChartComponent onNodeClick={onNodeClick} data={clubData} />
      )}
    </div>
  )
}

export default ClubComponent
